import {type FC} from "react"
import {Box, Stack} from "@mui/material"
import EllipsisTypography from "../../atoms/customTypography/EllipsisTypography"
import React from "react"
import TextSeparator from "../../atoms/separator/TextSeparator"
import useSelectedThoughtPiecesStore from "../../../stores/fullPageThoughtPiecesStore"
import {Link} from "react-router-dom"
import {ThoughtPiecesAuthorModel} from "../../../types/ThoughtPiecesModel"
import Author from "../../atoms/author/Author"
import {TruncatedTooltip} from "../../atoms/Tooltip"

type Props = {
  title: string
  paragraph: string
  authors: ThoughtPiecesAuthorModel[]
  date: string
  articleTag: string
  itemId: string
  itemUrl: string
}

const DiscoverMainItem: FC<Props> = (props) => {
  const {title, paragraph, authors, date, articleTag, itemId, itemUrl} = props

  const {setId} = useSelectedThoughtPiecesStore()

  return (
    <>
      <Box
        id="moleculeDiscoverMainItemLeftBox"
        sx={{
          padding: "0px",
          textAlign: "start",
          color: "#242d35",
          fontWeight: "normal",
          lineHeight: "56px",
          marginBottom: "6px",
          flex: 1,
          "&:hover": {
            textDecoration: "underline solid 1.5px",
            cursor: "pointer",
          },
          textDecoration: "none",
        }}
        component={Link}
        to={itemUrl}
        onClick={() => setId(itemId)}
      >
        <EllipsisTypography
          text={title}
          lines={4}
          fontSize={40}
          lineHeight="56px"
          tooltipComponent={TruncatedTooltip}
        ></EllipsisTypography>
      </Box>
      <Box
        id="moleculeDiscoverMainItemRightBox"
        style={{
          paddingLeft: "0px",
          marginLeft: "8px",
          marginRight: "9px",
          flex: "1",
        }}
      >
        <Stack>
          <Box
            style={{
              height: "10px",
              paddingRight: "50px",
              fontSize: "14px",
              textAlign: "start",
              marginBottom: "8px",
              color: "#595958",
              lineHeight: "1.33",
              flex: 1,
            }}
          >
            <EllipsisTypography
              text={paragraph}
              lines={8}
              fontSize={14}
              withEllipsis={false}
            ></EllipsisTypography>
          </Box>
          <Box
            style={{
              paddingRight: "50px",
              fontSize: "14px",
              textAlign: "start",
              marginTop: "20px",
              marginBottom: "8px",
              color: "#242d35",
              lineHeight: "1.33",
              overflow: "hidden",
              display: "flex",
              flexDirection: "row",
            }}
          >
            {authors.length > 1 ? (
              authors.map((author, index) => (
                <React.Fragment key={index}>
                  <Author authorId={author.group} origin="Discover">
                    <Box style={{flex: 2}}>
                      <EllipsisTypography
                        text={author.name}
                        lines={1}
                        fontSize={14}
                        tooltipComponent={TruncatedTooltip}
                      ></EllipsisTypography>
                    </Box>
                  </Author>
                  {index < authors.length - 1 && (
                    <TextSeparator
                      separator="|"
                      distanceX="7px"
                      paddingTop="3px"
                      fontSize="10px"
                      fontWeight="600"
                    />
                  )}
                </React.Fragment>
              ))
            ) : (
              <>
                {articleTag && (
                  <Box style={{flex: 2}}>
                    <EllipsisTypography
                      text={articleTag}
                      lines={1}
                      fontSize={14}
                      tooltipComponent={TruncatedTooltip}
                    ></EllipsisTypography>
                  </Box>
                )}
                {articleTag && authors.length == 1 && (
                  <TextSeparator
                    separator="|"
                    distanceX="7px"
                    paddingTop="3px"
                    fontSize="10px"
                    fontWeight="600"
                  />
                )}
                {authors.length == 1 && (
                  <Author authorId={authors[0].group} origin="Discover">
                    <Box style={{flex: 2}}>
                      <EllipsisTypography
                        text={authors[0].name}
                        lines={1}
                        fontSize={14}
                        tooltipComponent={TruncatedTooltip}
                      ></EllipsisTypography>
                    </Box>
                  </Author>
                )}
              </>
            )}
          </Box>
          <Box
            style={{
              paddingRight: "50px",
              fontSize: "14px",
              textAlign: "start",
              marginBottom: "8px",
              color: "#242d35",
              lineHeight: "1.33",
            }}
          >
            <EllipsisTypography
              text={date}
              lines={1}
              fontSize={14}
              tooltipComponent={TruncatedTooltip}
            ></EllipsisTypography>
          </Box>
        </Stack>
      </Box>
    </>
  )
}

export default DiscoverMainItem
